export default {"src":"/_next/static/media/stressMotivation.8028e87b.svg","height":593,"width":1047,"blurWidth":0,"blurHeight":0};